import { Button } from "rsuite";
import { Link } from 'react-router-dom';
import { AppRoutesUI } from '../../config/appRoutes';

export const AddUsersButton = () => {
  return (
    <Link to={AppRoutesUI.Users.UsersAdd()}>
      <Button className="listPage-add-button" appearance="primary" size="md">
        Add New User
      </Button>
    </Link>
  );
};
